<template>
  <v-card :color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <v-row class="no-gutters align-center">
      <v-col cols="12" sm="6" md="6" lg="8" :md="$canRoute('registered-user?tab=8') !== 1 ? 10 : 6" :lg="$canRoute('registered-user?tab=8') !== 1 ? 11 : 8">
        <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here ..."
          single-line solo hide-details>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="2" lg="1">
        <ul>
          <li>
            <span class="">Total Accounts</span>
            <span>{{ pagination?.total }}</span>
          </li>
        </ul>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="3" align="center" v-if="$canRoute('registered-user?tab=8') === 1">
        <ul>
          <li>
            <v-dialog transition="scale-transition" origin="center center" max-width="480" v-model="dialogModal"
              content-class="deposit-withdraw-popup marketingPopup">
              <template v-slot:activator="{ on, attrs }">
                <v-btn tile elevation="0" color="greenMain" v-bind="attrs" v-on="on">
                  <span class="testing-acc">+ New Testing Account</span>
                </v-btn>
              </template>
              <!-- Dialog content goes here -->
              <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                ">
                <v-card-title class="pb-3 text-left justify-start pl-3">
                  Add New Testing Account
                </v-card-title>
                <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                  Add An Existing Trading Account As Testing Account
                </v-card-subtitle>
                <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                  ">
                  <v-row>
                    <v-col cols="12">
                      <fieldset>
                        <legend>Account No</legend>
                        <v-text-field v-model="trading_account_no" label="Add Trading Account" single-line solo
                          hide-details class="custom-select"></v-text-field>
                      </fieldset>
                    </v-col>
                    <v-col cols="12">
                      <fieldset>
                        <legend>Comment</legend>
                        <v-text-field v-model="comment" label="Add comment" single-line solo hide-details
                          class="custom-select"></v-text-field>
                      </fieldset>
                    </v-col>

                  </v-row>
                </v-card>
                <v-card-actions>
                  <v-row dense>
                    <v-col cols="12">
                      <v-btn tile :loading="loading" :disabled="loading" @click="createTestingAccount" elevation="0"
                        class="text-capitalize btn-account mr-3 px-sm-8" color="greenMain">Create</v-btn>
                      <v-btn tile color="#FF567F" @click="dialogModal = false" elevation="0"
                        class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
            <v-data-table :headers="headers" :items="accounts" :server-items-length="pagination?.total || 10"
              :options.sync="options" :loading="isLoading" :items-per-page="options.itemsPerPage" :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:'
              }" @update:options="handleOptionsChange" disable-sort>
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <span class="ml-2">Loading data...</span>
                </div>
              </template>
              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>
              <template v-slot:no-results>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-magnify</v-icon>
                  <span class="ml-2">No matching data found</span>
                </div>
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ formatMySQLDate(item?.created_at) || "N/A" }}
              </template>
              <template v-slot:item.email="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                      {{ obfuscateAnyEmail(item?.email) }}
                      <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                        {{
                          copiedStates[item.id]
                            ? "mdi mdi-check"
                            : "mdi-content-copy"
                        }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item.email }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.accounts="{ item }">
                <router-link class="text-capitalize text--ash"
                  :to="`/registered-user-details/${item?.client_account_id}`">
                  {{ item?.fname }} {{ item?.lname }} {{ "(" + item?.client_account_id + ")" }}
                </router-link>
              </template>
              <template v-slot:item.leverage="{ item }">
                {{ 1 + ":" + item.leverage }}
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { formatMySQLDate } from "@/_helpers/formateDate";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import { TESTINGACCOUNTS__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import * as XLSX from "xlsx";

export default {
  data() {
    return {
      trading_account_no: null,
      comment: null,
      dialogModal: false,
      loading: false,
      search: "",
      searchTimeout: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      isCopied: false,
      copiedStates: {},
      headers: [
        { text: "Reg. Time", align: "start", value: "created_at" },
        { text: "Acc No", value: "trading_account_no" },
        { text: "Name", value: "accounts" },
        { text: "Email", value: "email" },
        { text: "Reference No", value: "reference_no" },
        { text: "Leverage", value: "leverage" },
        { text: "Currency", value: "currency_name" },
      ],
    };
  },
  computed: {
    ...mapState("testingaccounts", ["accounts", "pagination", "isLoading"]),
    ...mapState("admins", ["loggedAdmin"]),
  },
  methods: {
    formatMySQLDate,
    ...mapActions("testingaccounts", [
      TESTINGACCOUNTS__ACTIONS.TESTINGACCOUNTS,
      TESTINGACCOUNTS__ACTIONS.CREATETESTINGACCOUNT,
    ]),

    copyText(item) {
      navigator.clipboard.writeText(item.email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },

    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },

    downloadExcel() {
      const wb = XLSX.utils.book_new();
      const apiData = this.accounts;

      const modifiedData = apiData.map((item) => ({
        "USER ID": item.client_account_id,
        NAME: item?.accounts?.fullname,
        EMAIL: item.email,
        "REGISTERED AT": item.created_at,
        PASSWORD: item.password,
        "INVESTOR PASSWORD": item.investor_password,
        LEVERAGE: item.leverage,
        DEPOSIT: item.deposit || "N/A",
      }));

      const ws = XLSX.utils.json_to_sheet(modifiedData);
      XLSX.utils.book_append_sheet(wb, ws, "Demo Accounts");
      const totalRow = modifiedData.length + 2;

      ws["!ref"] = XLSX.utils.encode_range({
        s: { c: 0, r: 0 },
        e: { c: 9, r: totalRow },
      });

      XLSX.writeFile(wb, "demo_accounts.xlsx");
    },

    async fetchData() {
      const params = {
        page: this.options.page || 1,
        limit: this.options.itemsPerPage || 10,
        search: this.search,
      };

      await this[TESTINGACCOUNTS__ACTIONS.TESTINGACCOUNTS](params);
    },

    async handleSearch() {
      await this.fetchData();
    },

    debounceSearch() {
      //if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleOptionsChange(options) {
      this.fetchData();
    },

    async createTestingAccount() {
      this.loading = true;
      try {
        const parameter = {
          trading_account_no: this.trading_account_no,
          comment: this.comment,
        }
        await this[TESTINGACCOUNTS__ACTIONS.CREATETESTINGACCOUNT](parameter)
        this.trading_account_no = null;
        this.comment = null;
        this.dialogModal = false;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },


  },

  async created() {
    await this.fetchData();
  },
};
</script>

<style>
.testing-acc {
  padding-top: 5px;
  font-size: 14px !important;
  font-weight: normal !important;
  color: #fff !important;
  text-transform: capitalize !important;
}
</style>